// 专场类型
// [school] => 高校专场 [industry] => 行业专场 [area] => 区域专场 [company] => 名企专场  不传或为空则为全部","enabled":true}]
const sp_data = [
    { name: "高校专场", value: "school" },
    { name: "行业专场", value: "industry" },
    { name: "区域专场", value: "area" },
    // { name: "名企专场", value: "company" },
    { name: "实名企业专场", value: "realname" },
]

// 专场状态
// 状态1：进行中 2：报名中 3：已结束
const sp_state = [
    { name: "进行中", value: 1 },
    { name: "报名中", value: 2 },
    { name: "已结束", value: 3 },
]

// 在线状态
const online_state = [
    { name: "视频在线", value: 1 }
];
// 线下双选会 参会类型
const offline_type = [
    {name: '网上招聘', value: 1 },
    {name: '现场招聘', value: 0 }
];

// 公司规模
const company_scale = [
    { name: "少于50人", value: "少于50人" },
    { name: "50-150人", value: "50-150人" },
    { name: "150-500人", value: "150-500人" },
    { name: "500-1000人", value: "500-1000人" },
    { name: "1000-5000人", value: "1000-5000人" },
    { name: "5000-10000人", value: "5000-10000人" },
    { name: "10000人以上", value: "10000人以上" },
];

// 学历数据
const degree_data = [
    { name: "中专", value: '中专及以上' },
    { name: "大专", value: '大专及以上' },
    { name: "本科", value: '本科及以上' },
    { name: "硕士", value: '硕士及以上' },
    { name: "博士", value: '博士及以上' },
];
//薪资范围
const salary_data = [
    { name: "3k以下", value: "0,3" },
    { name: "3-5k", value: "3,5" },
    { name: "5-8k", value: "5,8" },
    { name: "8-12k", value: "8,12" },
    { name: "12-20k", value: "12,20" },
    { name: "20-50k", value: "20,50" },
    { name: "50k以上", value: "50,99999999" },
];
// 学历数据
const degree_data2 = [
    { name: "中专及以上", value: '中专及以上' },
    { name: "大专及以上", value: '大专及以上' },
    { name: "本科及以上", value: '本科及以上' },
    { name: "硕士及以上", value: '硕士及以上' },
    { name: "博士及以上", value: '博士及以上' },
];

// 工作类型
const work_type = [
    { name: "校招", value: 1 },
    { name: "实习", value: 2 },
    { name: "社招", value: 3 },
];

// 招聘人数
const hire_number = [
    { name: "1~5人", value: "1,5" },
    { name: "6~10人", value: "6,10" },
    { name: "11~20人", value: "11,20" },
    { name: "21~50人", value: "21,50" },
    { name: "51~100人", value: "51,100" },
    { name: "100人以上", value: "100, 100000" },
];

// 行业类型
const industry_data = [
    { name: '农林牧渔', value: '农、林、牧、渔业', },
    { name: '采矿', value: '采矿业', },
    { name: '制造', value: '制造业', },
    { name: '电力/能源供应', value: '电力、热力、燃气及水生产和供应业', },
    { name: '建筑', value: '建筑业', },
    { name: '采购贸易', value: '批发和零售业', },
    { name: '仓储物流', value: '交通运输、仓储和邮政业', },
    { name: '餐饮住宿', value: '住宿和餐饮业', },
    { name: 'IT互联网', value: '信息传输、软件和信息技术服务业', },
    { name: '金融', value: '金融业', },
    { name: '房地产', value: '房地产业', },
    { name: '租赁服务', value: '租赁和商务服务业', },
    { name: '科研/技术服务', value: '科学研究和技术服务业', },
    { name: '水利环保', value: '水利、环境和公共设施管理业', },
    { name: '居民服务', value: '居民服务、修理和其他服务业', },
    { name: '教育', value: '教育', },
    { name: '卫生/社会工作', value: '卫生和社会工作', },
    { name: '文娱', value: '文化、体育和娱乐业', },
    { name: '公共/社会管理', value: '公共管理、社会保障和社会组织', },
    { name: '国际组织', value: '国际组织', },
    { name: '军队', value: '军队' },
];

export {
    sp_data, sp_state, online_state, company_scale, degree_data, work_type, hire_number, industry_data, salary_data, degree_data2, offline_type
}



// WEBPACK FOOTER //
// ./src/datas/kind.js